import { Injectable, NgZone } from '@angular/core';
import { Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take'
import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import {appState} from './appState';
declare var firebase: any;
import * as moment from 'moment';
export class person {   
    
    parentGroup: string="";
    visibility: boolean = true;
    admins: Array<any> = new Array();
    members: Array<any> = new Array();
    

    email: string="";
    phone: string="";
    emergencyName: string="";
    emergencyPhone: string="";
    photoURL: string="";
    uid: string = "";
    gender: string="";
    dob: string="";
    bloodGroup: string="";
    constructor(public key: string, public displayName: string) {
        
    }
    toJson() {
        return {
            parentGroup: this.parentGroup,
            visibility: this.visibility ,
            admins: this.admins ,
            members: this.members ,
            
            displayName: this.displayName,
            gender: this.gender  ,
            dob: this.dob ,
            bloodGroup: this.bloodGroup,

            email: this.email,
            phone: this.phone,
            emergencyName: this.emergencyName,
            emergencyPhone: this.emergencyPhone,
            photoURL: this.photoURL,
            uid: this.uid
        }
    }
}
@Injectable()
export class personModel {
    meRef: FirebaseObjectObservable<any>;    
    me: person = new person('a','Name');
    constructor(
        private af: AngularFire,
        private platform: Platform,
        private _appState: appState

    ) {
        var that = this;
        this.platform.ready().then(() => {
            that.af.auth.subscribe(auth => {
                if (auth == null)
                {
                    this.af.auth.login();
                } else {
                    that.createIfNotExist(auth.uid);
                    that._appState.auth = auth.auth;
                }
            });
        });
    }
    createIfNotExist(uid) {
        var that = this;
        that.meRef = that.af.database.object('/persons/' + uid);        
        that.watch();
        var objSubscribe = that.meRef.take(1).map(snapshot => {
            if (snapshot.$value !== null) {
                that.me = snapshot;                                
            } else {
                //var a = that.parentRef.push({ 'key': auth.uid, 'name': 'rama' }); 
                that.af.database.object('/persons/' + uid).set(new person(uid, that._appState.auth.displayName));
            }
        });
    }
    watch() {
        var that = this;
        this.meRef.subscribe(obj => {
            that.me = Object.assign(this.me, obj);
            if (that.me.displayName == null || that.me.displayName == undefined || that.me.displayName == '' || that.me.displayName == "Name") {
                that.me.displayName = that._appState.auth.displayName;        
                that.me.photoURL = that._appState.auth.photoURL;
                that.me.uid = that._appState.auth.uid;
                if (!(that.me.displayName == null || that.me.displayName == undefined || that.me.displayName == '' || that.me.displayName == "Name"))
                    that.update();
            }
        });
    }     
    update() {
        this.meRef.update(this.me.toJson());  
    }   
}
@Injectable()
export class statsRecord {
    yearRef: FirebaseObjectObservable<any>;
    monthRef: FirebaseObjectObservable<any>;
    weekRef: FirebaseObjectObservable<any>;
    year: any = {};
    week: any = {};
    month: any = {};
    uid: string;
    constructor(private af: AngularFire,
        private platform: Platform,
        private _appState: appState,
        private _ngZone: NgZone,
        private personModel: personModel
    ) {
        var that = this;
        var that = this;
        this.platform.ready().then(() => {
            that.af.auth.subscribe(auth => {
                if(auth == null) return;
                that.uid = auth.uid;
                var dad = moment(new Date());
                console.log(dad);
                var mon:number = dad.month() + 1;
                that.yearRef = that.af.database.object('/personsRecord/' + that.uid + "/year/" + dad.year());
                that.monthRef = that.af.database.object('/personsRecord/' + that.uid + "/month/" + mon);
                that.weekRef = that.af.database.object('/personsRecord/' + that.uid + "/week/" + dad.week());
                that.watch();
            });
        });
    }
    create(year, month, week) {
        var that = this;
        

        that.yearRef.take(1).map(snapshot => {
            if (snapshot.$value !== null) {
                that.year = snapshot;
            } else {           
                that.af.database.object('/personsRecord/' + that.uid + "/year/" + year).set({'key':year});
            }
        });
        that.monthRef.take(1).map(snapshot => {
            if (snapshot.$value !== null) {
                that.month = snapshot;
            } else {
                that.af.database.object('/personsRecord/' + that.uid + "/month/" + month).set({ 'key': month });
            }
        });
        that.weekRef.take(1).map(snapshot => {
            if (snapshot.$value !== null) {
                that.week = snapshot;
            } else {
                that.af.database.object('/personsRecord/' + that.uid + "/week/" + year).set({ 'key': week });
            }
        });
    }
    watch() {
        var that = this;
        this.yearRef.subscribe(obj => {
            this.year = Object.assign(this.year, obj);
            console.log(this.year);
        });
        this.monthRef.subscribe(obj => {
            this.month = Object.assign(this.month, obj);
        });
        this.weekRef.subscribe(obj => {
            that._ngZone.run(() => {
                this.week = Object.assign(this.week, obj);
                console.log(this.week);
            })
        });
    }     

    
    addTo(location, locationValue, event, eventValue:number) {
        var that = this;
        this.addToGroup(location, locationValue, event, eventValue);
        var ObjRef: FirebaseObjectObservable<any> = that.af.database.object('/personsRecord/' + that.uid + "/" + location + "/" + locationValue);
        that.af.database.object('/personsRecord/' + that.uid + "/" + location + "/" + locationValue).update({ 'dummy': false });
        console.log(ObjRef);
        var sub = ObjRef.take(1).subscribe(snapshot => {
            if (snapshot.$value !== null) {
                if (snapshot[event] !== null && snapshot[event] != undefined) {
                    var obj = {};
                    obj[event] = eventValue + snapshot[event];                    
                     ObjRef.update(obj);  
                }
                else {
                    var obj = {};
                    obj[event] = eventValue;                    
                    ObjRef.update(obj);  
                }

            } else {
                var obj = {};
                obj[event] = eventValue;
                sub.unsubscribe();
                that.af.database.object('/personsRecord/' + that.uid + "/" + location + "/" + locationValue).set(obj);
            }
        },
            (err) => { console.log(err)},
        () => { console.log("done") }
        );
        console.log(sub);
    }
    addToGroup(location, locationValue, event, eventValue) {
        var that = this;
        this.personModel.me.members.forEach(function (groupid, index, arry) {            
            var ObjRef: FirebaseObjectObservable<any> = that.af.database.object('/groupRecord/' + groupid + "/" + location + "/" + locationValue);
            that.af.database.object('/groupRecord/' + groupid + "/" + location + "/" + locationValue).update({ 'dummy': false });
            console.log(ObjRef);
            var sub = ObjRef.take(1).subscribe(snapshot => {
                if (snapshot.$value !== null) {
                    if (snapshot[event] !== null && snapshot[event] != undefined) {
                        var obj = {};
                        obj[event] = eventValue + snapshot[event];
                        ObjRef.update(obj);
                    }
                    else {
                        var obj = {};
                        obj[event] = eventValue;
                        ObjRef.update(obj);
                    }

                } else {
                    var obj = {};
                    obj[event] = eventValue;
                    sub.unsubscribe();
                    that.af.database.object('/groupRecord/' + groupid + "/" + location + "/" + locationValue).set(obj);
                }
            },
                (err) => { console.log(err) },
                () => { console.log("done") }
            );
            console.log(sub);
        });
    }
    getGroupRecord(groupName) {
        return new groupRecord(this.af, this.platform, this._appState, this._ngZone, this.personModel, groupName);
    }
}
export class groupRecord {
    yearRef: FirebaseObjectObservable<any>;
    monthRef: FirebaseObjectObservable<any>;
    weekRef: FirebaseObjectObservable<any>;
    year: any = {};
    week: any = {};
    month: any = {};

    yearSub: any;
    weekSub: any;
    monthSub: any;
    uid: string;
    constructor(
        private af: AngularFire,
        private platform: Platform,
        private _appState: appState,
        private _ngZone: NgZone,
        private personModel: personModel,
        public groupName:string
    ) {
        var that = this;        
        this.platform.ready().then(() => {
            that.af.auth.subscribe(auth => {
                that.uid = auth.uid;
                var dad = moment(new Date());
                console.log(dad);
                var mon: number = dad.month() + 1;
                that.yearRef = that.af.database.object('/'+groupName+'/' + that.uid + "/year/" + dad.year());
                that.monthRef = that.af.database.object('/' + groupName + '/' + that.uid + "/month/" + mon);
                that.weekRef = that.af.database.object('/' + groupName + '/' +that.uid + "/week/" + dad.week());
                that.watch();
            });
        });
    }
    watch() {
        var that = this;
        this.yearSub=this.yearRef.subscribe(obj => {
            this.year = Object.assign(this.year, obj);
            console.log(this.year);
        });
        this.monthSub =this.monthRef.subscribe(obj => {
            this.month = Object.assign(this.month, obj);
        });
        this.weekSub =this.weekRef.subscribe(obj => {
            that._ngZone.run(() => {
                this.week = Object.assign(this.week, obj);
                console.log(this.week);
            })
        });
    }     
    unsubscribe() {
        this.yearSub.unsubscribe();
        this.monthSub.unsubscribe();
        this.weekSub.unsubscribe();
    }
}

@Injectable()
export class teamModel {
    meRef: FirebaseListObservable<any>;
    me: any = [];
    constructor(
        private af: AngularFire,
        private platform: Platform,
        private _appState: appState

    ) {
        var that = this;
        this.platform.ready().then(() => {
            that.af.auth.subscribe(auth => {
                if (auth != null) {                    
                    that._appState.auth = auth.auth;
                    that.meRef = that.af.database.list('/persons');
                    that.meRef.subscribe(personsList => {
                        that.me = Object.assign(this.me, personsList);;
                    });
                }
            });
        });
    }
    getItem(personid,metric,metricInstance) {
        var that = this;
        var myRunning: FirebaseObjectObservable<any>;
        var link = '/personsRecord/' + personid + '/' + metric + "/" + metricInstance
        console.log(link); 
        myRunning=that.af.database.object(link);
        return myRunning;
    }
}


// WEBPACK FOOTER //
// ./src/model/personModel.ts